import Logo from "../../statics/logo/logo-purls.svg";
import { BsClipboard } from "react-icons/bs";
import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { FaUsers, FaUserPlus, FaUserCog } from "react-icons/fa";
import { useAppSelector } from "../../store/hooks";

import winner from "../../statics/img/icons/winner.svg";
import sweepstakes from "../../statics/img/icons/sweepstakes.svg";

// import { RiHome3Line } from "react-icons/ri";
// import Tooltip from "../Tooltip";
// import Dropdown from "../Dropdown";
interface Props {
  isOpen: boolean;
}
const Siderbar = ({ isOpen }: Props) => {
  const { skills } = useAppSelector((store) => store.user);
  //console.log(skills)
  const DEV = process.env.REACT_APP_DEVELOPMENT;
  const divref = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();

  const navigate = useNavigate();
  return (
    <div
      ref={divref}
      className={`c-sidebard ${isOpen && `c-sidebard--visible`}`}
    >
      {/* sidebard */}
      <div className="c-sidebard__content">
        {/* haeder */}
        <div className="c-sidebard__box-header">
          <img src={Logo} alt="PURLs logo" className="c-sidebard__logo" />
        </div>
        <nav className="c-sidebard__nav">
          {/*  <div className={`c-sidebard__nav-item ${pathname === '/purls' && `c-sidebard__nav-item--active`}`} onClick={() => navigate('/purls')}>
            <span className="c-sidebard__nav-item-icon"><RiHome3Line /></span>
            <span className="c-sidebard__nav-item-title">Dashboard</span>
          </div> */}
          {/* <Dropdown overlay={Menu} placement="right-start" margin={25}> */}
          {/* <Tooltip text="Agents Modules" placement="right" margin={22}> */}
          <div
            className={`c-sidebard__nav-item ${
              pathname.includes("/mypurls/campaigns") &&
              `c-sidebard__nav-item--active`
            }`}
            onClick={() => navigate("/mypurls/campaigns")}
          >
            <span className="c-sidebard__nav-item-icon">
              <BsClipboard />
            </span>
            <span className="c-sidebard__nav-item-title">My PURLs</span>
          </div>
          {skills.includes("public.users.employees.list") ||
          skills.includes("super.admin") ||
          skills.includes("admin.employee.manager.list") ? (
            <div
              className={`c-sidebard__nav-item ${
                pathname.includes("/mypurls/employee") &&
                `c-sidebard__nav-item--active`
              }`}
              onClick={() => navigate("/mypurls/employee")}
            >
              <span className="c-sidebard__nav-item-icon">
                <FaUsers />
              </span>
              <span className="c-sidebard__nav-item-title">Employee</span>
            </div>
          ) : null}

          {skills.includes("publlic.users.roles.manage") ||
          skills.includes("super.admin") ? (
            <div
              className={`c-sidebard__nav-item ${
                pathname.includes("/mypurls/roles") &&
                `c-sidebard__nav-item--active`
              }`}
              onClick={() => navigate("/mypurls/roles")}
            >
              <span className="c-sidebard__nav-item-icon">
                <FaUserCog />
              </span>
              <span className="c-sidebard__nav-item-title">Roles</span>
            </div>
          ) : null}

          {skills.includes("public.users.skills.manage") ||
          skills.includes("super.admin") ? (
            <div
              className={`c-sidebard__nav-item ${
                pathname.includes("/mypurls/skills") &&
                `c-sidebard__nav-item--active`
              }`}
              onClick={() => navigate("/mypurls/skills")}
            >
              <span className="c-sidebard__nav-item-icon">
                <FaUserPlus />
              </span>
              <span className="c-sidebard__nav-item-title">Skills</span>
            </div>
          ) : null}
          {(skills.includes("admin.sweepstakes.list") ||
            skills.includes("super.admin")) && (
            <div
              className={`c-sidebard__nav-item ${
                pathname.includes("/mypurls/sweepstakes") &&
                `c-sidebard__nav-item--active`
              }`}
              onClick={() => navigate("/mypurls/sweepstakes")}
            >
              <span className="c-sidebard__nav-item-icon">
                <img src={sweepstakes} alt="" />
              </span>
              <span className="c-sidebard__nav-item-title">Sweepstakes</span>
            </div>
          )}
          {(skills.includes("admin.raffle.list") ||
            skills.includes("super.admin")) && (
            <div
              className={`c-sidebard__nav-item ${
                pathname.includes("/mypurls/winner") &&
                `c-sidebard__nav-item--active`
              }`}
              onClick={() => navigate("/mypurls/winner")}
            >
              <span className="c-sidebard__nav-item-icon">
                <img src={winner} alt="" />
              </span>
              <span className="c-sidebard__nav-item-title">Get a Winner</span>
            </div>
          )}

          {/* {DEV === "true" && <></>} */}
          {/*  </Tooltip> */}
          {/*  </Dropdown> */}
        </nav>
      </div>
    </div>
  );
};

export default Siderbar;
